module.exports = __webpack_public_path__ + "static/media/vf_mknit_core.e2d25789.svg";